<ideal-product-section
  i18n-title="@@products.alternates.label"
  title="Similar Products"
  navAnchorId="app.main-menu/products/details/alternates"
  navAnchorHeading="Product"
  i18n-navAnchorHeading="@@products.nav.product.heading"
  [navAnchorHidden]="hasContent() === false"
  class="no-bg"
>
  <ideal-product-alternates #content [productId]="id()"></ideal-product-alternates>
</ideal-product-section>
